import PropTypes from 'prop-types';
import React from 'react'

import History from './Sidebar-ViewHistory'
import Bookmarks from './Sidebar-Bookmarks'
import Questions from './Sidebar-Questions'


export default class extends React.Component {
    static propTypes = {
		filter: PropTypes.string,
		feed: PropTypes.object,
		session: PropTypes.object.isRequired
	};

    render() {

		return (

			<div className="right-sidebar bg-white">

				{ ( () => {
					switch (this.props.filter) {
						case "history": 	return <History posts={this.props.session.history} fetching={this.props.session.fetching.history} />
						default: 			return <Bookmarks bookmarks={this.props.session.bookmarks} fetching={this.props.session.fetching.bookmarks} />
					}
				} )() }

	        </div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/SideBarRight/SideBar-Master.jsx